const wireName = (type, index) => `${type}-wire-${index}`;

export default wireName;
